<template>
  <div>
    <div class="table-container">
      <vue-good-table
          styleClass="vgt-table table table-stat"
          :columns="columns"
          :rows="rows"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'id', type: 'desc'}
          }"
          :pagination-options="{
            enabled: true,
            perPage: 25,
            perPageDropdown: [10, 25, 50, 100],
            dropdownAllowAll: false,
            jumpFirstOrLast : true,
            rowsPerPageLabel: 'Строк на странице',
            allLabel: 'Все',
            ofLabel: 'из',
            prevLabel: 'Назад',
            nextLabel: 'Вперед',
            firstLabel : 'В начало',
            lastLabel : 'В конец',
          }"
          compactMode
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'feedId'">
            <router-link v-if="props.row.feedId > 0" class="link" :to="{ name: 'FeedId', params: { id: props.row.feedId }}">{{ props.row.feedName }}</router-link>
            <span v-else>-</span>
          </span>
          <template v-else-if="props.column.field === 'changes'">
            <ChangesList :changes="props.row.changes" />
          </template>
          <span v-else v-html="props.formattedRow[props.column.field]"></span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import ChangesList from '@/components/ChangesList.vue';
import Vue from 'vue';

export default {
  name: 'Changelogs',
  components: { ChangesList },
  data: function() {
    return {
      rows: [],
    };
  },
  computed: {
    columns(t) {
      return [
        {
          label: 'ID',
          field: 'id',
          type: 'number',
          sortable: true,
        },
        // {
        //   label: 'IP',
        //   field: 'clientIp',
        //   sortable: false,
        // },
        // {
        //   label: 'Useragent',
        //   field: 'useragent',
        //   sortable: false,
        // },
        {
          label: 'Фид',
          field: 'feedId',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Все',
            filterDropdownItems: t.allFeeds,
          },
        },
        {
          label: 'Действие',
          field: 'message',
          sortable: false,
        },
        {
          label: 'Изменения',
          field: 'changes',
          sortable: false,
        },
        {
          label: 'Время',
          field: 'timestamp',
          sortable: false,
          formatFn: (val) => {
            return (new Date(val)).toLocaleString();
          },
        },
      ];
    },
    allFeeds() {
      const feeds = [];
      this.rows.forEach(item => {
        if (item.feedId > 0) {
          feeds[item.feedId] = {
            value: item.feedId,
            text: `${item.feedName} (id=${item.feedId})`,
          };
        }
      });
      return Object.values(feeds).sort((a, b) => a.text.localeCompare(b.text));
    },
  },
  created() {
    Vue.prototype.$reload = () => this.fetchData();
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.$globalSpinner.show();
        this.rows = await this.$api.getChangelogs();
      } catch (err) {
        console.error(err);
        this.$notification.error('Ошибка загрузки логов');
      } finally {
        this.$globalSpinner.hide();
      }
    },
  },
};
</script>
